import React, { Component } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { components } from 'react-select';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import './_attendanceReport.scss';
import moment from 'moment';


class ExcelContainerForAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }


  render() {
    console.log("stateDatastateData", this.props.excalData)

    return (
      <>
        <ReactHTMLTableToExcel
          id="test-table-xls-button-new"
          className="btn text-uppercase btn-success"
          table="table-to-xls-new"
          filename="Student_Attendance_report"
          sheet="Student_Attendance_report"
          buttonText="DOWNLOAD REPORT"
        />
        <table id="table-to-xls-new" style={{ display: "none" }}>
          <thead>
          <tr>
              <th rowSpan="2">Student Name</th>
              <th rowSpan="2">Roll no</th>
              <th colSpan={this.props.stateData.dateArrayfinal.length}>Dates</th>
          </tr>

          <tr>
              {
                  this.props.stateData.dateArrayfinal.map((item => {
                      return (<th>{item}</th>)
                  }))
              }
          </tr>
          </thead>
          <tbody>
            {
                this.props.stateData.getStudenWiseAttendanceData.length > 0 ?
                    (
                        this.props.stateData.getStudenWiseAttendanceData.map((item) => {
                            return (
                                <>
                                    <tr>
                                        <td>{item.student_name}</td>
                                        <td>{item.roll_no}</td>
                                        {
                                            item.dayWiseData.map((item2) => {
                                                return (
                                                  <>
                                                    {
                                                        item2.attendance_status == "P" ?
                                                        (
                                                          <td style={{ textAlign: "center", fontSize: "16px",color:"#5BB453",fontWeight:"bold"}}>
                                                            {item2.attendance_status}
                                                          </td>
                                                        )
                                                        :
                                                        (
                                                          item2.attendance_status == "A" ?
                                                          (
                                                            <td style={{ textAlign: "center", fontSize: "16px",color:"#B45353",fontWeight:"bold"}}>
                                                              {item2.attendance_status}
                                                            </td>
                                                          )
                                                          :
                                                          (
                                                            <td style={{ textAlign: "center", fontSize: "16px",color:"#D59954",fontWeight:"bold"}}>
                                                              {item2.attendance_status}
                                                            </td>
                                                          )
                                                        )
                                                    }
                                                  </>
                                                   
                                                )
                                            })
                                        }
                                    </tr>
                                </>
                            )
                        })
                    )
                    :
                    (
                        ""

                    )
            }
          </tbody>
        </table>
      </>
    )
  }
}

export default ExcelContainerForAttendance;



